import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import guidesContent from '../data/guidesContent';
import { setMeta } from '../utils/seo';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function GuideDetail() {
  const navigate = useNavigate();
  const query = useQuery();
  const title = query.get('title') || '';
  const [html, setHtml] = useState('');

  const getContentForTitle = (t) => {
    const list = guidesContent[t];
    if (!list || list.length === 0) return `<p>未找到与 “${t}” 对应的文章静态内容。</p>`;
    return list[0];
  };

  useEffect(() => {
    const content = getContentForTitle(title);
    setHtml(content);
    
    // 智能提取描述 (取前120个字符，移除HTML标签)
    const plainText = (content && typeof content === 'string') 
      ? content.replace(/<[^>]+>/g, '').replace(/\s+/g, ' ').trim().slice(0, 120) + '...'
      : '德州扑克教学文章';

    // set meta for article-like detail page
    setMeta({
      title: title ? `${title} - HHpoker德扑技巧` : '文章详情 - HHpoker',
      description: plainText,
      keywords: `${title || '德州扑克'}, 德扑教学, 扑克技巧, 德扑圈攻略, HHpoker, 进阶策略`,
      url: window.location.origin + '/guide/',
      robots: 'noindex,follow',
      image: window.location.origin + '/images/art1.jpeg',
      type: 'article',
      jsonLd: {
        "@context": "https://schema.org",
        "@type": "Article",
        "headline": title || '文章详情',
        "description": plainText,
        "datePublished": new Date().toISOString(), // 理想情况下应该从 guidesContent 获取日期，但这需要重构数据结构
        "author": { 
            "@type": "Organization", 
            "name": "HHpoker" 
        },
        "publisher": {
            "@type": "Organization",
            "name": "HHpoker",
            "logo": {
                "@type": "ImageObject",
                "url": window.location.origin + "/images/logo.png"
            }
        }
      }
    });
  }, [title]);

  const titleRef = useRef(null);

  useEffect(() => {
    // 当标题或内容变化时，滚动并聚焦到标题，确保用户定位到文章顶部
    if (titleRef.current) {
      try {
        titleRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        titleRef.current.focus();
      } catch (err) {
        // ignore
      }
    }
  }, [title, html]);

  return (
    <div className="page-root guide-detail-page" style={{ background: '#1a1c29', color: '#fff', minHeight: '100vh', padding: '40px 8vw' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12 }}>
               <button onClick={() => navigate(-1)} aria-label="返回" style={{ background: 'transparent', border: 'none', color: '#efa765', fontSize: '1.4rem', cursor: 'pointer', padding: 0 }}>
            &#8592;
        </button>
        <h1 ref={titleRef} tabIndex={-1} style={{ color: '#efa765', margin: 0 }}>{title || '文章详情'}</h1>
       
      </div>
      {/* 内容为一对一静态映射（不再随机切换） */}
      <div style={{ background: '#222431', padding: 24, borderRadius: 8 }} dangerouslySetInnerHTML={{ __html: html }} />
    </div>
  );
}

export default GuideDetail;
